<template>
  <div
    :class="[
      `h-[43px] ${workspace_user_permission_scope && workspace_user_permission_scope !== 'admin' ? 'opacity-0 pointer-events-none' : ''}`
    ]"
    class="fixed z-40 overflow-visible transition-all duration-300 rounded-md bg-transparent dark:bg-dark-box-background top-6 right-[187px] border-0 flex space-x-0">
    <!-- <button v-if="editModeActive" class="absolute z-20 -ml-44 btn cancel-btn" @click="setEditMode(false)">Save changes</button> -->

    <div>
      <Menu
        v-slot="{ close: close_main_menu }"
        :class="{ 'pointer-events-none': !dynamic_data_source_active }"
        as="div"
        class="relative inline-block px-3 mt-1.5 -ml-1 text-left">
        <MenuButton>
          <Database
            :color="!dynamic_data_source_active ? 'lightgrey' : $store.state.ui_options.theme.button_color"
            class="cursor-pointer w-5 h-5" />
        </MenuButton>

        <!-- Sidebar user menu -->
        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
          @blur="handleBlur">
          <!-- mx wil have to be adjusted on the "closed" variant to align with where the user picture is -->
          <MenuItems
            class="duration-200 z-10 absolute w-[300px] right-2 mt-1 mb-6 rounded-md shadow-lg bg-white dark:bg-dark-screen-background ring-1 py-2 ring-blue ring-opacity-5 focus:outline-none">
            <div v-for="item in data_source_options_list" :key="item.name" class="cursor-pointer text-sm">
              <div v-if="item?.divider" class="bg-gray-300 my-1 h-[1px] w-[80%] mx-auto" />
              <div v-else-if="item.id == 'object_selection'" class="py-2 px-1 ml-3">
                <ComboBoxInput
                  v-model:current-item="selected_object_type"
                  :disabled="currentTemplate.layout.length > 1"
                  :value="selected_object_type"
                  :items="$store.state.object_types"
                  name="object_type"
                  classes="w-full relative dark:text-white"
                  label-attr="label"
                  value-attr="type"
                  :is-box-background="true"
                  :label="$t('Object Type')"
                  :show-label="true"
                  :floating-label="false"
                  :allow-null="false" />
              </div>

              <Menu v-else
                    v-slot="{ close }"
                    ref="goalsMenu"
                    as="div"
                    class="relative flex-shrink-0">
                <MenuButton
                  class="focus:outline-none focus:ring-1 w-full hover:bg-gray-100 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue">
                  <div class="flex py-4" @click="handleClick(item)" @mouseleave="handleMouseLeave">
                    <component
                      :is="item.icon"
                      v-if="item.icon"
                      :color="$store.state.ui.darkMode ? '#A2E0F8' : '#0a698f'"
                      class="w-5 h-5 mr-3 transition ease-in-out hover:text-dark-body-text text-common-grey duration-side-menu-transition-duration"
                      aria-hidden="true" />
                    <ChevronLeft class="w-4 h-4 mr-2 ml-2" />
                    {{ item.name }}
                    {{ item.id == "group" && selected_group ? `: ${selected_group.name}` : "" }}
                    {{
                      item.id == "specific_record" && selected_specific_record ? `: ${$utils.getRecordName(selected_specific_record)}` : ""
                    }}
                    <span v-if="item.keyBoardShortcut" class="flex ml-auto text-sm font-semibold text-right text-gray-400">
                      <span class="">⌘</span>
                      <span class="uppercase">{{ item.keyBoardShortcut }}</span>
                    </span>
                  </div>
                </MenuButton>
                <transition
                  enter-active-class="transition duration-100 ease-out"
                  enter-from-class="transform scale-95 opacity-0"
                  enter-to-class="transform scale-100 opacity-100"
                  leave-active-class="transition duration-75 ease-in"
                  leave-from-class="transform scale-100 opacity-100"
                  leave-to-class="transform scale-95 opacity-0">
                  <MenuItems class="absolute z-50 w-40 mx-3 mt-3 -ml-48 origin-bottom-right bg-transparent border-0 focus:outline-none">
                    <span
                      v-if="show_side_menu == item.id"
                      class="w-[270px] absolute top-28 h-full inline-flex items-center px-2 py-1 -ml-[60px] mt-14 rounded-md text-sm whitespace-nowrap dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
                      <div class="p-2 h-[500px] w-64">
                        <div class="h-16 border rounded-md bg-white p-2">
                          <SelectGroupDropDownMenu
                            v-if="item.id == 'group'"
                            v-model:current-item="selected_group"
                            :focus-trigger="focus_trigger"
                            :reset-trigger="reset_group_trigger"
                            :clear-on-select="true"
                            :items="
                              $store.state.data?.groups.filter(
                                (group) => group.type == selected_object_type && group.organization == $store.state.organization.id
                              )
                            "
                            :object-type="selected_object_type"
                            :clear-selected-item="!selected_group ? true : false"
                            label-attr="name"
                            name="groups"
                            :placeholder="$t('Groups')"
                            class="relative"
                            :is-box-background="true"
                            :input-classes="`'w-32 sm:text-sm appearance-none h-10 font-medium text-gray-700 text-left block px-1 py-2 rounded-lg shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light`"
                            @groupSelection="handleGroupSelected(close, close_main_menu)" />

                          <AsyncMultiSelectCompaniesInput
                            v-if="item.id == 'specific_record'"
                            :multi-select="false"
                            :object-type="selected_object_type"
                            :focus-trigger="focus_trigger"
                            :add-label="$utils.capitalize($utils.makePlural(selected_object_type))"
                            :clear-on-select="true"
                            :is-box-background="true"
                            :value="selected_specific_record ? [selected_specific_record] : []"
                            classes="w-full"
                            input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm "
                            name="companies"
                            value-attr="id"
                            :endpoint="`/api/organizations/${$store.state.organization.id}/records/filter/`"
                            endpoint-method="post"
                            search-field="name"
                            type="text"
                            :placeholder="$t($utils.capitalize($utils.makePlural(selected_object_type)))"
                            @update:currentItems="
                              ($event) => {
                                handleChangeSelectedRecord($event, close, close_main_menu)
                              }
                            " />
                        </div>
                      </div>
                    </span>
                  </MenuItems>
                </transition>
              </Menu>
            </div>
          </MenuItems>
        </transition>
      </Menu>
    </div>
  </div>
</template>

<script>
import ModuleIcon from "@/components/shared/icons/ModuleIcon.vue"
import QuickActionsIcon from "@/components/shared/icons/QuickActionsIcon.vue"
import { Database } from "lucide-vue-next"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import { ChevronLeft } from "lucide-vue-next"
import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"
import SelectGroupDropDownMenu from "@/components/shared/SelectGroupDropDownMenu.vue"
import AsyncMultiSelectCompaniesInput from "@/components/shared/AsyncMultiSelectCompaniesInput.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    ChevronLeft,
    Database,
    AsyncMultiSelectCompaniesInput,
    SelectGroupDropDownMenu,
    ComboBoxInput,
    ModuleIcon,
    QuickActionsIcon,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems
  },
  inject: ["setPageLayout"],
  props: {
    currentTemplate: {
      type: Object,
      required: true
    },
    pageReference: {
      type: String,
      required: true
    }
  },
  emits: ["update:currentTemplate"],

  data() {
    return {
      selected_object_type: "company",
      focus_trigger: 1,
      reset_group_trigger: 1,
      tooltip_active: true,
      selected_group: null,
      selected_specific_record: null,
      selected_data_source: null,
      prevent_watch_trigger: false,
      hide_selection: false,
      show_side_menu: null
    }
  },
  computed: {
    dynamic_data_source_active() {
      let is_active = true
      this.currentTemplate?.layout.map((layout) => {
        if (
          this.selected_data_source == "group" &&
          this.selected_group &&
          (layout.props.component_type == "record_title" ||
            layout.props.component_type == "checklist" ||
            layout.props.component_type == "company_map" ||
            layout.props.component_type == "overview" ||
            layout.props.component_type == "owners" ||
            layout.props.component_type == "key_people" ||
            layout.props.component_type == "last_touch" ||
            layout.props.component_type == "last_quality_touch" ||
            layout.props.component_type == "notes")
        ) {
          is_active = false
        }
        if (
          this.selected_data_source == "specific_record" &&
          this.selected_specific_record &&
          (layout.props.component_type == "forecast_table" || layout.props.component_type == "journey")
        ) {
          is_active = false
        }
      })
      if (!is_active) {
        return false
      }
      return true
      //return this.selected_group || this.selected_specific_record
    },
    data_source_options_list() {
      if (this.currentTemplate.layout.length > 1 && this.selected_group) {
        return [{ id: "object_selection" }, { divider: true }, { name: this.$t("Group"), id: "group", has_side_menu: true }]
      }
      if (this.currentTemplate.layout.length > 1 && this.selected_specific_record) {
        return [
          { id: "object_selection" },
          { divider: true },
          { name: this.$t("Specific Record"), id: "specific_record", has_side_menu: true }
        ]
      }
      return [
        { id: "object_selection" },
        { divider: true },
        { name: this.$t("Specific Record"), id: "specific_record", has_side_menu: true },
        { name: this.$t("Group"), id: "group", has_side_menu: true }
      ]
    },
    workspace_user_permission_scope() {
      if (this.$route.name !== "WorkspaceItem") {
        return null
      }
      return this.$store.state.ui.workspace_user_access_scope
    }
  },
  watch: {
    currentTemplate() {
      this.initSelections()
    },
    selected_group() {
      this.tooltip_active = false
      setTimeout(() => {
        this.tooltip_active = true
      }, 1000)
      if (this.selected_group) {
        this.selected_specific_record = null
      }
      if (!this.prevent_watch_trigger) {
        this.setDynamicDataSourceLayoutComponent()
      }
    },
    selected_specific_record() {
      this.tooltip_active = false
      setTimeout(() => {
        this.tooltip_active = true
      }, 1000)
      if (this.selected_specific_record) {
        this.selected_group = null
        this.reset_group_trigger += 1
      }
      if (!this.prevent_watch_trigger) {
        this.setDynamicDataSourceLayoutComponent()
      }
    },
    selected_object_type() {
      this.reset_group_trigger += 1
      this.selected_group = null
      this.selected_specific_record = null

      if (!this.prevent_watch_trigger) {
        this.setDynamicDataSourceLayoutComponent()
      }
    }
  },

  created() {
    this.initSelections()
  },
  methods: {
    handleBlur() {
      this.show_side_menu = null
    },
    initSelections() {
      this.prevent_watch_trigger = true
      setTimeout(() => {
        this.prevent_watch_trigger = false
      }, 2000)
      const settings_component_in_layout = this.currentTemplate?.layout.find((l) => l.id == "dynamic_source_selection")
      if (settings_component_in_layout) {
        const data_source_array = settings_component_in_layout.data_source_string.split(">")
        this.selected_object_type = data_source_array[0]
        this.selected_data_source = data_source_array[1]
        if (data_source_array[1] == "group") {
          this.selected_group = this.$store.state.data?.groups.find((g) => g.id == data_source_array[2])
        } else if (data_source_array[1] == "specific_record") {
          this.$store
            .dispatch("data/getRecord", data_source_array[2])
            .then((res) => {
              this.selected_specific_record = res.data
            })
            .catch(() => {
              setTimeout(() => {
                this.$store.dispatch("data/getRecord", data_source_array[2]).then((res) => {
                  this.selected_specific_record = res.data
                })
              }, 800)
            })
        }
      }
    },
    handleClick(item) {
      if (item.id !== this.show_side_menu) {
        this.show_side_menu = item.id
        this.triggerFocus()
      } else {
        this.show_side_menu = null
      }
    },
    handleMouseLeave() {
      this.hide_selection = false
    },

    handleGroupSelected(close, close_main_menu) {
      close()
      close_main_menu()
      setTimeout(() => {
        if (this.currentTemplate.layout.length < 2) {
          this.$emitter.emit(ALL_EMITTERS.ADD_NEW_COMPONENT, {
            page_reference: this.pageReference,
            current_template: this.currentTemplate
          })
        }
      }, 800)
    },
    handleChangeSelectedRecord(e, close, close_main_menu) {
      close()
      close_main_menu()
      this.selected_specific_record = e[0]
      setTimeout(() => {
        if (this.currentTemplate.layout.length < 2) {
          this.$emitter.emit(ALL_EMITTERS.ADD_NEW_COMPONENT, {
            page_reference: this.pageReference,
            current_template: this.currentTemplate
          })
        }
      }, 800)
    },
    triggerFocus() {
      this.$utils.debounce(() => {
        this.focus_trigger += 1
      }, 0)
    },
    setDynamicDataSourceLayoutComponent() {
      if (!this.selected_group && !this.selected_specific_record) {
        this.removeDynamicDataSourceLayoutComponent()
        return
      }

      let data_source_string = ""
      if (this.selected_group) {
        data_source_string = `${this.selected_object_type}>group>${this.selected_group.id}`
      } else if (this.selected_specific_record) {
        data_source_string = `${this.selected_object_type}>specific_record>${this.selected_specific_record.id}`
      }

      const current_template_clone = this.$utils.clone(this.currentTemplate)
      const settings_component_obj = {
        props: { hidden: true, component_type: "dynamic_source_selection" },
        id: "dynamic_source_selection",
        data_source_string: data_source_string
      }

      this.$utils.replaceOrAddItem(current_template_clone.layout, settings_component_obj)

      current_template_clone.layout.forEach((component) => {
        if (component.id !== "dynamic_source_selection") {
          const component_clone = this.$utils.clone(component)
          if (this.selected_group) {
            if (component_clone.props.component_type == "rollup" || component_clone.props.component_type == "score") {
              component_clone.props.component_props.dataSource = this.selected_group.id
              component_clone.props.component_props.linkedRecord = null
              component_clone.props.component_props.objectType = this.selected_object_type
            } else if (component_clone.props.component_type == "graph") {
              component_clone.props.component_props.dataSource = this.selected_group.id
            } else {
              component_clone.props.component_props.view_by = this.selected_group.id
            }
          } else if (this.selected_specific_record) {
            if (component_clone.props.component_type == "notes") {
              component_clone.props.component_props.connectTo = "this_page"
              component_clone.props.component_props.linked_to = "specific_record"
              component_clone.props.component_props.recordId = this.selected_specific_record.id
            } else if (component_clone.props.component_type == "record_table") {
              component_clone.props.component_props.dataSource = "another_record"
              component_clone.props.component_props.linkedRecord = this.selected_specific_record.id
              component_clone.props.component_props.objectType = this.selected_object_type
              component_clone.props.component_props.preservedMainFilter = ""
              component_clone.props.component_props.preservedColumnsFilters = ""
            } else if (component_clone.props.component_props.initialFilter || component_clone.props.component_type == "action_table") {
              if (this.selected_object_type == "company") {
                component_clone.props.component_props["initialFilter"] = {
                  contacts: [],
                  companies: [this.selected_specific_record]
                }
              } else if (this.selected_object_type == "contact") {
                component_clone.props.component_props["initialFilter"] = {
                  companies: [],
                  contacts: [this.selected_specific_record]
                }
              }
            } else if (component_clone.props.component_type == "rollup" || component_clone.props.component_type == "score") {
              component_clone.props.component_props.dataSource = "another_record"
              component_clone.props.component_props.linkedRecord = this.selected_specific_record.id
              component_clone.props.component_props.objectType = this.selected_object_type
            } else if (component_clone.props.component_props.linkedRecord) {
              component_clone.props.component_props.linkedRecord = this.selected_specific_record.id
            }
          }
          this.$utils.replaceOrAddItem(current_template_clone.layout, component_clone)
        }
      })
      this.setPageLayout(current_template_clone)
      this.$emit("update:currentTemplate", current_template_clone)
      this.$emitter.emit(ALL_EMITTERS.LAYOUT_UPDATED, {
        layout: current_template_clone,
        silent: true
      })
    },

    removeDynamicDataSourceLayoutComponent() {
      const current_template_clone = this.$utils.clone(this.currentTemplate)
      this.$utils.removeItem(current_template_clone.layout, {
        id: "dynamic_source_selection"
      })

      this.setPageLayout(current_template_clone)
      this.$emit("update:currentTemplate", current_template_clone)
      this.$emitter.emit(ALL_EMITTERS.LAYOUT_UPDATED, {
        layout: current_template_clone,
        silent: true
      })
    }
  }
}
</script>
